<template>
  <div class="cart-panel-btn">
    <h4 v-if="isFloorTableAvailable.table_id">
      <span class="active dinein">{{ _T('Dinein Booking') }}</span>
    </h4>
    <ul v-else>
      <li
        :class="{ active: order_type === CONST.ORDER_TYPE_ONLINE }"
        @click="setOrderType(CONST.ORDER_TYPE_ONLINE)"
      >
        {{ _T('delivery') }}
      </li>
      <li
        :class="{ active: order_type === CONST.ORDER_TYPE_TAKEAWAY }"
        @click="setOrderType(CONST.ORDER_TYPE_TAKEAWAY)"
      >
        {{ _T('carry out') }}
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import * as CONST from '@/constants'
export default {
  data() {
    return {
      activeOT: CONST.ORDER_TYPE_ONLINE,
    }
  },
  computed: {
    ...mapGetters(['_T', 'isFloorTableAvailable', 'order_type']),
  },
  methods: {
    setOrderType(orderType) {
      // this.activeOT = orderType
      this.$store.commit('SET_ORDER_TYPE', orderType)
    },
  },
}
</script>
<style lang="scss" scoped>
.cart-panel-btn {
  padding: $px16;
  // margin-top: $px12;
  background-color: $white;
  ul {
    li {
      background: $white;
      border: $px1 solid $light-border;
      border-radius: $px4;
      text-transform: capitalize;
      width: 49% !important;
      padding: $px9 0;
      font-size: $px16;
      font-weight: normal;
      line-height: $px19;
      letter-spacing: 0.02em;
      color: $light-font;
      text-align: center !important;
      cursor: pointer;
      &.active {
        background: $color-primary;
        border: $px1 solid $color-primary;
        color: $white;
        font-weight: 600;
      }
      &.dinein {
        width: 100% !important;
      }
      &:nth-child(2) {
        margin-left: -$px4;
      }
    }
  }
}
.body-rtl {
  .cart-panel-btn {
    ul {
      padding-right: 0;
      justify-content: space-between;
      display: flex;
    }
  }
}
</style>
